import type { StepType } from "@reactour/tour";
import { text } from "@quickpoint.me/shared";
import TourStepContent from "../../wrapper";

const goodbye: StepType[] = [
	{
		selector: "window",
		content: () => <TourStepContent description={() => text.tourSteps.goodbyeMessage} />,
		position: "center",
	},
];

export default goodbye;
